import {Component, computed, inject, input} from '@angular/core';
import {Rating, WineProduct} from '@core/interfaces/generated/graphql';

import {CustomerReviewsAndWishlistService} from '@core/services/customer-reviews-and-wishlist.service';
import {
  ProductCompactRatingComponent
} from '@layout/components/product/product-compact-rating/product-compact-rating.component';

@Component({
  selector: 'app-product-ratings',
  templateUrl: './product-ratings.component.html',
  styleUrls: ['./product-ratings.component.scss'],
  imports: [ProductCompactRatingComponent]
})
export class ProductRatingsComponent {
  private customerReviewsAndWishlistService = inject(CustomerReviewsAndWishlistService);


  readonly product = input.required<WineProduct>();
  showCustomerRating = input<boolean>(true)
  customerRating: Rating | undefined;

  ratings = computed(() => {
    const ratings = this.product()?.meta?.ratings;
    if (!ratings) {
      return [];
    }
    // Filter out previous vintage ratings for the sidebar display
    return ratings.filter(d => !!d && !d.isPreviousVintage && ((d?.rating ?? 0) > 0 || (d?.starCount ?? 0) > 0 || (d?.label?.length ?? 0) > 0)) as Rating[];
  });

  getCustomerReviewAsRating(product: WineProduct): Rating {
    if (!this.customerRating) {
      let customerReview = this.customerReviewsAndWishlistService.customerReviews().find(review => review?.product?.id === product.id);

      this.customerRating = {
        rating: customerReview?.rating ?? 0,
        starCount: 5,
        name: $localize`Din rating`,
      };
    }
    return this.customerRating;
  }
}
